<template>
  <div class="wrap">
    <div class="newswrap">
      <div class="part1">
        <Head />
        <p class="p1">{{$t('m_newslist.tit')}}</p>
        <p class="p2">NEWS</p>
      </div>
      <div class="list">
         <p class="p1">
             {{title}}
         </p>
        <p class="p2">
            {{$t('m_newslist.time')}}{{createdTime}}
        </p>
        <div class="fuwenben" v-html="content">
            
        </div>
      </div>
    </div>

    <Foot />
  </div>
</template>
<script>
import Head from "../../components/mobile/Head.vue";
import Foot from "../../components/mobile/Foot.vue";
import api from "../../common/api";
export default {
  data() {
    return {
      lang:localStorage.getItem('Lang'),
      title:'',
      createdTime:'',
      content:''
    };
  },
  components: {
    Head,
    Foot
  },
  created(){
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.$axios
        .get(api.getReportDetail, {
          params: {
            id: this.$route.params.id,
            lang:this.lang
          }
        })
        .then(res => {
          this.title = res.data.title;
          this.createdTime = res.data.createdTime.substring(0, 10);
          this.content = res.data.content;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/mixin';

.newswrap {
  min-height: calc(100vh - 19.3333vw);
}

.part1 {
  height: vw(650);
  width: vw(750);
  overflow: hidden;
  margin-top: vw(98);
  background: url('../../assets/images/mobile/newslist/bg.png') no-repeat center;
  background-size: 100% 100%;

  .p1 {
    font-size: vw(40);
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    line-height: vw(40);
    margin: vw(60) 0 vw(9);
  }

  .p2 {
    margin-left: vw(361);
    font-size: vw(60);
    color: #fff;
    opacity: 0.12;
    line-height: vw(60);
  }

  .image {
    width: vw(570);
    height: vw(386);
    margin: 0 auto;
    margin-top: vw(113);

    img {
      width: 100%;
      height: 100%;
    }
  }
}
.list{
    padding vw(72) vw(40)  vw(75)
    .p1{
        font-size:vw(32);
        color:rgba(68, 68, 68, 1);
        line-height:vw(48);
        text-align center;
    }
    .p2{
        margin-top vw(25)
        font-size:vw(24);
        color:#bbbbbb;
        line-height:vw(24);
        text-align center
        padding-bottom vw(40)
        border-bottom vw(2) solid rgba(229, 229, 229, 1);
    }
    .fuwenben{
        padding-top vw(40)
        padding-bottom vw(100)
        >>>p {
          word-wrap: break-word;
          img{
            width 100%
            height auto
          }
        }
        >>>img{
          width 100%
          height auto
        }
    }
}
</style>
